import React, { useState } from 'react';
import { IconUsers, IconBriefcase, IconCalendarStar, IconUserSearch } from '@tabler/icons-react';
import Layout from '../components/Layout';
import Employees from './Employees';
import Clients from './Clients';
import Holidays from './Holidays';
import Requirements from './Requirements';

// Consolidates the admin-only "manage company reference data" pages —
// Employees, Clients, Holidays, Requirements — into one nav entry with
// internal tabs, instead of each claiming its own sidebar slot.
// Announcements and Leaves stay as separate top-level pages since VAs use
// those directly; everything here is admin-only with nothing for a VA to
// reach.
const TABS = [
  { key: 'employees', label: 'Employees', Icon: IconUsers, Component: Employees },
  { key: 'clients', label: 'Clients', Icon: IconBriefcase, Component: Clients },
  { key: 'holidays', label: 'Holidays', Icon: IconCalendarStar, Component: Holidays },
  { key: 'requirements', label: 'Recruitment', Icon: IconUserSearch, Component: Requirements },
];

export default function HQ() {
  const [activeTab, setActiveTab] = useState('employees');
  const ActiveComponent = TABS.find((t) => t.key === activeTab).Component;

  return (
    <Layout>
      <div className="p-4 sm:p-6">
        <h1 className="text-xl font-bold text-ink">HQ</h1>
        <p className="text-sm text-muted mt-0.5">Company-wide records — employees, clients, holidays, and hiring.</p>

        <div className="flex sm:inline-flex rounded-lg border border-border bg-card p-0.5 text-xs font-semibold mt-4">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              title={tab.label}
              className={`flex-1 sm:flex-initial flex items-center justify-center gap-1.5 px-2 sm:px-3 py-1.5 rounded-md transition-colors whitespace-nowrap ${
                activeTab === tab.key ? 'bg-gold text-white' : 'text-muted hover:text-ink'
              }`}
            >
              <tab.Icon size={16} stroke={2} />
              <span className="hidden sm:inline">{tab.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-6">
          <ActiveComponent />
        </div>
      </div>
    </Layout>
  );
}
